(function () {
  'use strict';

  function FvSlider(container) {
    this.container = container;
    this.slides = Array.from(container.querySelectorAll('.fv-slide'));
    this.current = 0;
    this.interval = parseInt(container.dataset.interval, 10) || 3000;
    this.timer = null;

    if (this.slides.length > 1) {
      this._start();
    }
  }

  FvSlider.prototype._start = function () {
    var self = this;
    this.timer = setInterval(function () {
      self._next();
    }, self.interval);
  };

  FvSlider.prototype._next = function () {
    this.slides[this.current].classList.remove('fv-slide--active');
    this.current = (this.current + 1) % this.slides.length;
    this.slides[this.current].classList.add('fv-slide--active');
  };

  FvSlider.prototype.destroy = function () {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  };

  function initSliders() {
    document.querySelectorAll('.js-fv-slider').forEach(function (container) {
      new FvSlider(container);
    });
  }

  document.addEventListener('DOMContentLoaded', initSliders);

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('.js-fv-slider').forEach(function (container) {
      new FvSlider(container);
    });
  });
})();
